import React, { useState } from "react";
import Contact from "../../components/Contact.js";
import { hireAndroidFaqs } from "../../components/faqData.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const AndroidDevelopers = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (<>
    <Helmet>
      <meta name="description" content="Hire experienced Android developers in India to build fast, secure & scalable mobile apps. Get expert solutions for your project. Contact us today!"/>
<meta name="copyright" content="codeglim"/>
<meta property="og:title" content="Hire Experienced Android Developers in India | Ayanshtech Solutions"/>
<meta property="og:site_name" content="Ayanshtech Solutions"/>
<meta property="og:url" content="https://ayanshtechnology.com/hire-android-developers"/>
<meta property="og:description" content="Hire experienced Android developers in India to build fast, secure & scalable mobile apps. Get expert solutions for your project. Contact us today!"/>
<meta property="og:type" content="website"/>
<meta property="og:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<meta name="twitter:card" content="summary"/>
<meta name="twitter:site" content="@Ayanshtech Solutions"/>
<meta name="twitter:title" content="Hire Experienced Android Developers in India | Ayanshtech Solutions"/>
<meta name="twitter:description" content="Hire experienced Android developers in India to build fast, secure & scalable mobile apps. Get expert solutions for your project. Contact us today!"/>
<meta name="twitter:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<link rel="canonical" href="https://ayanshtechnology.com/hire-android-developers"/>
<title>Hire Experienced Android Developers in India | Ayanshtech Solutions</title>
    </Helmet>
    <div className="min-h-screen flex flex-col items-center justify-center p-6">
      <div className=" p-4 w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16 mt-10">
          <div className="lg:w-3/4 lg:text-left">
            <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
              Hire Experienced Android Developers in India
            </h1>
            <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3">
              Android development is essential for building engaging and
              scalable mobile apps that reach a wide audience. At Ayanshtech, we
              offer expert Android developers who specialize in Kotlin, Java,
              and Android SDK, enabling you to create top-quality apps tailored
              to your business needs. Whether you need a new app, app
              optimization, or feature integration, our developers are skilled
              at providing seamless, high-performance solutions.
              <br />
              <br />
              With years of experience, our Android development team can help
              take your app ideas to the next level. Hire Android developers
              from Ayanshtech to build and maintain outstanding mobile
              applications for your business, ensuring optimal performance and a
              great user experience.
            </p>
            <p className="  text-gray-600 sm:text-lg md:text-xl lg:text-xl">
              Starting from just <span className="font-bold">US $14/hour</span>
            </p>
            <button
              onClick={scrollToContact}
              className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold p-3 rounded-full mt-6"
            >
              Hire a Android Developer
            </button>
          </div>
          <div className="flex justify-center  mb-12 mt-5">
            <img
              src="\assets\images\headerSection\hireAndroidDev\img1.png"
              alt="Android App Development"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Expertise Of Our Android Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Hire Android developers from Ayanshtech with the expertise to create
          custom mobile solutions for your brand.
        </p>
      </div>

      <div className=" p-4 ">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon1.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Android App Prototyping, Wireframes, and Mockups
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon2.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">UI/UX Designing for Android Apps</p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon3.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Custom Android App Development</p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon4.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Android App Testing and Cloud Integration</p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon5.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Expert Coding and Debugging</p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon6.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Android App Upgrade and Maintenance</p>
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-20">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Seasoned Android Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl ">
          Hire professional Android App Developers from Ayanshtech to bring your
          Android app ideas to life.
        </p>
      </div>

      <div className=" ">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/2 p-4">
            <img
              src="\assets\images\headerSection\hireAndroidDev\img2.png"
              alt="Laptop with graph"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className=" md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />

              <div>
                <p className="text-lg">
                  Choose from a team of highly skilled Android developers for
                  hire
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  You will get a daily report on your working hours or as per
                  your requirement
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Our consultant will help you shortlist and interview Android
                  programmer for hire to find the right expert for your project
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  With our various hiring models, you can hire as per your
                  development requirement
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AyanshtechAdvantage />

      <div className="max-w-3xl mx-auto mt-10 p-4 w-full">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
          FAQs
        </h2>
        {hireAndroidFaqs.map((faq, index) => (
          <div key={index} className="border-b-2 border-blue-300">
            <button
              onClick={() => toggleFAQ(index)}
              className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                activeIndex === index
                  ? "bg-blue-600 text-white px-5 rounded-2xl"
                  : ""
              }`}
            >
              <span className="text-lg">{faq.question}</span>
              <span className="text-2xl">
                {activeIndex === index ? "-" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="p-4 text-gray-700">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>

      <div id="contact-section">
        {" "}
        <Contact />
      </div>
      <GetInTouch />
    </div>
  </>);
};

export default AndroidDevelopers;
